/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

import Card from "../Card";
import { monthDays } from "../functions/Month";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: { display: false },
    datalabels: {
      display: false,
    },
    tooltip: {
      backgroundColor: "#1F2937",
      titleColor: "#fff",
      bodyColor: "#D1D5DB",
      borderColor: "#10B981",
      borderWidth: 1,
      cornerRadius: 6,
      padding: 10,
      callbacks: {
        title: (tooltipItems) => `${tooltipItems[0].label}-kuni`,
        label: (tooltipItem) => ` ${tooltipItem.raw} ta`,
      },
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: { color: "#9CA3AF" },
    },
    y: {
      beginAtZero: true,
      grid: { color: "rgba(209, 213, 219, 0.2)" },
      ticks: { color: "#9CA3AF" },
    },
  },
  elements: {
    point: {
      radius: 3,
      hoverRadius: 6,
      backgroundColor: "#10B981",
      borderWidth: 1,
      borderColor: "#fff",
    },
    line: {
      borderWidth: 2,
    },
  },
};

const Chart1 = ({ datas, month }) => {
  const labels = Array.from({ length: monthDays(month) }, (_, i) => i + 1);

  const data = {
    labels,
    datasets: [
      {
        data: labels.map((l) => datas?.[`kun${l}`] || null),
        borderColor: "rgba(36, 123, 195, 0.9)",
        backgroundColor: "rgba(36, 123, 195, 0.2)",
        fill: true,
        tension: 0.4,
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#rgba(36, 123, 195, 0.9)",
      },
    ],
  };

  return (
    <Card>
      <div className='chart-box-all bg-white p-2'>
        <h4
          style={{
            fontSize: "18px",
            fontWeight: "bold",
          }}
          className=' text-gray-800 text-center'>
          Oylik Ko'rsatgichlar
        </h4>

        <div>
          <Line options={options} data={data} height={260} />
        </div>
      </div>
    </Card>
  );
};

export default Chart1;
